import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Wrench, ThermometerSimple, BatteryCharging, Gear, PaintBrush, CheckCircle,
  MagnifyingGlass, Lightning, Drop, ArrowRight,
} from "@phosphor-icons/react";
import { api } from "@/lib/api";

const ICONS = {
  Wrench, OilCan: Drop, DiscBall: Gear, Tire: Gear,
  MagnifyingGlass, ThermometerSimple, BatteryCharging, Gear,
  PaintBrush, CheckCircle, Lightning,
};

export default function ServicesGrid({ compact = false }) {
  const [services, setServices] = useState([]);

  useEffect(() => {
    api.get("/services").then((r) => setServices(r.data)).catch(() => {});
  }, []);

  return (
    <section data-testid="services-grid" className="py-20 md:py-32 px-6 md:px-12 bg-white tech-grid">
      <div className="max-w-[1400px] mx-auto">
        <div className="grid md:grid-cols-12 gap-12 items-end mb-16">
          <div className="md:col-span-7">
            <span className="overline text-[#E63946]">Nos services</span>
            <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0D2C54] tracking-tight">
              Une expertise complète, sous un même toit.
            </h2>
          </div>
          <p className="md:col-span-5 text-[#555555] leading-relaxed">
            De la révision constructeur à la préparation au contrôle technique, en passant par le diagnostic électronique et la carrosserie : nous couvrons toutes les interventions sur votre véhicule.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 border-l border-t border-[#E5E7EB]">
          {(compact ? services.slice(0, 8) : services).map((s, i) => {
            const Icon = ICONS[s.icon] || Wrench;
            return (
              <div
                key={s.slug}
                data-testid={`service-card-${s.slug}`}
                className="group relative bg-white border-r border-b border-[#E5E7EB] p-8 md:p-10 hover:bg-[#0D2C54] transition-colors duration-300"
              >
                <div className="flex items-start justify-between">
                  <Icon size={36} weight="duotone" className="text-[#E63946] transition-transform group-hover:scale-110" />
                  <span className="overline text-[10px] text-[#555555] group-hover:text-white/40">0{i + 1}</span>
                </div>
                <h3 className="mt-8 font-display font-semibold text-xl text-[#0D2C54] group-hover:text-white">
                  {s.title}
                </h3>
                <p className="mt-3 text-sm text-[#555555] group-hover:text-white/80 leading-relaxed min-h-[60px]">
                  {s.description}
                </p>
                <Link
                  to={`/rendez-vous?service=${s.slug}`}
                  data-testid={`service-rdv-${s.slug}`}
                  className="mt-6 inline-flex items-center gap-2 text-sm font-semibold text-[#E63946] group-hover:text-[#E63946] link-arrow"
                >
                  Prendre rendez-vous <ArrowRight size={16} weight="bold" />
                </Link>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
